import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface ILeaseAuditState {
    data: Array<IEcaasLeaseAudit> | null;
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    showLoading: ILoading;
    leaseAuditDetails: IEcaasLeaseAudit | null;
}

// Define the initial state using that type
const initialState: ILeaseAuditState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    leaseAuditDetails: null
};

export const leaseAuditSlice = createSlice({
    name: 'leaseAudit',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
      setLoading: (state, action) => {
        state.showLoading = {
        sourceAction: action.payload.sourceAction,
        state: action.payload.value,
        };
      },
        resetLoading: (state, action) => {
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
        },
        replaceItems: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;

            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        setleaseAuditDetails: (state, action) => {
            state.leaseAuditDetails = action.payload.data;
        }
    },
});

export const leaseAuditActions = leaseAuditSlice.actions;

export default leaseAuditSlice.reducer;
